export const isDefined = (value: unknown) => {
    return value !== null && value !== undefined;
};
